import React from "react"
import PropTypes from "prop-types"
import Hidden from "@mui/material/Hidden"
import Grid from "@mui/material/Grid"
import SwipeableWithPager from "./SwipeableWithPager"

// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
const withWidth = () => (WrappedComponent) => (props) => (
  <WrappedComponent {...props} width="xs" />
)

// A grid of items on desktop
// A horizontally swipable of items on mobile.
// Takes an array of items.

const renderDesktopItem = (item, i) => (
  <Grid item xs={12} sm={4} md={3} key={i}>
    {item}
  </Grid>
)

const renderMobileItem = (item, i) => (
  <div key={i} style={{ margin: 2 }}>
    {item}
  </div>
)

const GridToSwipeable = ({ items, ...other }) => (
  <div {...other}>
    <Hidden smDown>
      <Grid container spacing={5}>
        {items.map((item, i) => renderDesktopItem(item, i))}
      </Grid>
    </Hidden>
    <Hidden smUp>
      <SwipeableWithPager
        items={items.map((item, i) => renderMobileItem(item, i))}
      />
    </Hidden>
  </div>
)

GridToSwipeable.propTypes = {
  items: PropTypes.array.isRequired,
}

export default withWidth()(GridToSwipeable)
